import { render } from "./IconOther.vue?vue&type=template&id=9dac566e"
import script from "./IconOther.vue?vue&type=script&lang=js"
export * from "./IconOther.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__